import { Routes } from '@angular/router'
import { LoginComponent } from './login/login.component'
import { AuthGuard } from './services/auth.guard'
import { CreaEnteGuard } from './services/crea-ente.guard'
import { SuperAdminGuard } from './services/super-admin.guard'
import { LeftSidebarComponent } from './left-sidebar/left-sidebar.component'
import { DEVICES } from './devices/devices.routing'
import { SOFTWARES } from './software/software.routing'
import { VULNERABILITY } from './vulnerability/vulnerability.routing'
import { IMPORT } from './import.routing'

/**
 * Routing configuration for the application.

 * This array defines the routes and their corresponding components, including lazy loading and child routes for modularization.

 * @export
 * @constant ROUTES
 */
export const ROUTES: Routes = [
    { path: 'login/:codiceAutoLogin', component: LoginComponent  },
    { path: 'login', component: LoginComponent  },
    {
        path: 'seleziona-organizzazione',
        loadComponent: () =>
            import('./seleziona-organizzazione/seleziona-organizzazione.component').then(
                (c) => c.SelezionaOrganizzazioneComponent
            ),
    },
    {
        path: 'crea-ente',
        loadComponent: () =>
            import('./features/enti/crea-ente/crea-ente.page').then((c) => c.CreaEntePage),
        canActivate: [CreaEnteGuard],
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    {
        path: '',
        component: LeftSidebarComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                loadComponent: () =>
                    import('./features/statistiche/statistiche.page').then(
                        (c) => c.StatistichePage
                    ),
            },
            {
                path: 'devices',
                loadComponent: () =>
                    import('./devices/devices.component').then((c) => c.DevicesComponent),
                children: DEVICES,
            },
            {
                path: 'services',
                loadComponent: () =>
                    import('./features/services/services.page').then((c) => c.ServicesPage),
            },
            {
                path: 'backups',
                loadComponent: () =>
                    import('./features/backups/backups.page').then((c) => c.BackupsPage),
            },
            {
                path: 'software',
                loadComponent: () =>
                    import('./software/software.component').then((c) => c.SoftwareComponent),
                children: SOFTWARES,
            },
            {
                path: 'associations',
                loadComponent: () =>
                    import('./features/associations/associations.page').then(
                        (c) => c.AssociationsPage
                    ),
            },
            {
                path: 'installazioni-software',
                loadComponent: () =>
                    import('./features/installazioni-software/installazioni-software.page').then(
                        (c) => c.InstallazioniSoftwarePage
                    ),
            },
            {
                path: 'anagrafica',
                loadComponent: () =>
                    import('./features/fornitori/fornitori.page').then((c) => c.FornitoriPage),
            },
            {
                path: 'vulnerability',
                loadComponent: () =>
                    import('./vulnerability/vulnerability.component').then(
                        (c) => c.VulnerabilityComponent
                    ),
                children: VULNERABILITY,
            },
            {
                path: 'report',
                loadComponent: () =>
                    import('./report/report.component').then(
                        (c) => c.ReportComponent
                    ),
            },
            {
                path: 'scan-results',
                loadComponent: () =>
                    import('./scan-results/scan-results.component').then(
                        (c) => c.ScanResultsComponent
                    ),
            },
            {
                path: 'schedule-scan',
                loadComponent: () =>
                    import('./schedule-scan/schedule-scan.component').then(
                        (c) => c.ScheduleScanComponent
                    ),
            },
            {
                path: 'start-sync-mua',
                loadComponent: () =>
                    import('./start-sync-mua/start-sync-mua.component').then(
                        (c) => c.StartSyncMuaComponent
                    ),
            },
            {
                path: 'scan-configuration',
                loadComponent: () =>
                    import('./scan-configuration/scan-configuration.component').then(
                        (c) => c.ScanConfigurationComponent
                    ),
            },
            {
                path: 'import',
                children: IMPORT,
            },
            {
                path: 'admin/enti',
                loadComponent: () =>
                    import('./features/enti/enti-admin/enti-admin.page').then(
                        (c) => c.EntiAdminPage
                    ),
                canActivate: [SuperAdminGuard],
            },
            {
                path: 'admin/attributi-globali',
                loadComponent: () =>
                    import('./features/attributes-admin/attributes-admin.page').then(
                        (c) => c.AttributesAdminPage
                    ),
                canActivate: [SuperAdminGuard],
            },
        ],
    },

]
